import service from '@/store/services/arqueos-service';
import Jsona from 'jsona';

const jsona = new Jsona();

export const state = () => ({
  list: {},
  meta: {},
  arqueo: {},
  url: null
});

export const mutations = {
  SET_LIST: (state, list) => {
    state.list = list;
  },
  SET_META: (state, meta) => {
    state.meta = meta;
  },
  SET_URL: (state, url) => {
    state.url = url;
  },
  SET_RESOURCE: (state, arqueo) => {
    state.arqueo = arqueo;
  },
};

export const actions = {
  list({commit, dispatch}, params = {}) {
    return service.list(params, this.$axios)
      .then(({list, meta}) => {
        commit('SET_LIST', list);
        commit('SET_META', meta);
      });
  },

  getMotivoIngreso({commit, dispatch}, params) {
    return service.getDatosVenta(params, this.$axios)
      .then((arqueo) => { commit('SET_LIST', arqueo); });
  },

  getMotivoEgreso({commit, dispatch}, params) {
    return service.getDatosVenta(params, this.$axios)
      .then((arqueo) => { commit('SET_LIST', arqueo); });
  },

  add({commit, dispatch}, params) {
    return service.add(params, this.$axios)
      .then((arqueo) => { commit('SET_RESOURCE', arqueo); });
  },
};

const getters = {
  list: state => state.list,
  listTotal: state => state.meta.total, 
  getMotivoIngreso: state => state.arqueo,
  getMotivoEgreso: state => state.arqueo,
  url: state => state.url
};

const arqueos = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};

export default arqueos;
